import { mapState, mapActions } from '@/store/helpers';


import * as TYPES from '../../_store/types';

import { recentListingStatus } from '../../_config';
export default {
    inject: ['normalizedFilter'],
    computed: {

        ...mapState({
            "listingStatus": store => store.listingStatus,
            "currentListingStatus": store => store.currentListingStatus,
            "hasLocation": store => store.hasLocation,
            "listingParams": "listingParams"
        }),
        
        
    },
    methods: {

        ...mapActions({
            "getListing": TYPES.GET_LISTING,
            "setCurrentListingStatus": TYPES.SET_CURRENT_LISTING_STATUS,
            "setCurrentListingName": TYPES.SET_CURRENT_LISTING_NAME,
            "fetchListingStatus": store => store.fetchListingStatus,
            "setFetchListingStatus": TYPES.SET_FETCH_LISTING_STATUS,
            "setCurrentPage": TYPES.SET_PAGE_NUM
        }),
        
        
        //  Click to navigate 
        switchNav(listing) {
            if (listing.id === this.currentListingStatus) {
                return; 
            }
            this.setCurrentListingStatus({ data: listing.id });
            this.setCurrentListingName({ data: listing.name });
            this.fetchListingData();
        },
        //  Get property data 
        async fetchListingData() {
            this.setFetchStatus();
            if (!this.hasLocation) {
                return; 
            }
            this.setCurrentPage({ data: 1 }); //  paged as 1
            const params = {
                ... this.normalizedFilter,
                ...this.listingParams
            };
            try {
                await this.getListing({ data: params });
                this.setFetchStatus(recentListingStatus.loaded);
            } catch (err) {
                // TODO  exception handling 
                // throw err;
            }
        },
        //  set up recent listing The state the module is in 
        async setFetchStatus(status) {
            if (status) {
                return this.setFetchListingStatus({ data: status }); 
            }
            if (!this.hasLocation) {
                status = recentListingStatus.noLocation; // no location
            } else {
                if (this.fetchListingStatus === recentListingStatus.coming) {
                    status = recentListingStatus.coming; // coming soon
                } else {
                    status = recentListingStatus.loading; // loading
                }
            }
            this.setFetchListingStatus({ data: status });
        }
        //  Is there a choice location data 
        // hasLocation() {
        //     return !!this.searchParams.key;
        // }
    }
};
